import { NgIf } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ArmazenamentoDeBaseService } from 'src/app/shared/services/armazenamento';
import { carregarImagemComFallback } from 'src/app/shared/utils/carregar-imagem-com-fallback';

@Component({
  selector: 'app-login-container',
  standalone: true,
  imports: [RouterModule, NgIf],
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.scss']
})
export class LoginContainerComponent implements OnInit, OnDestroy {
  private backgroundOverlayGradient = 'linear-gradient(180deg, rgba(0, 37, 74, 0) 0%, #00101F 100%)';
  private loginFallback = 'assets/imagens/backgrounds/login-background.jpg';
  private destroy$ = new Subject<void>();

  constructor(
    public armazenamentoDeBaseService: ArmazenamentoDeBaseService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.armazenamentoDeBaseService.base
    .pipe(takeUntil(this.destroy$))
    .subscribe(dados => {
      const loginBackgroundEl = this.el.nativeElement.querySelector('#login-left');

      if (loginBackgroundEl && dados != null) {
        carregarImagemComFallback(
          dados?.img_fundo_link || '',
          this.loginFallback,
          (src) => this.renderer.setStyle(
            loginBackgroundEl,
            'background-image',
            `${this.backgroundOverlayGradient}, url(${src})`
          ),
        );
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}